import React from 'react';
import { Button, Flex, InputNumber, Radio, Tabs } from 'antd';
import { CheckOutlined, DeleteOutlined, SelectOutlined } from '@ant-design/icons';

const ScanDirectionContent = (props) => {
  return (
    <Flex vertical>
      <Radio.Group onChange={(event) => props.setScanDirection(event.target.value)} defaultValue={props.scanDirection}>
        <Radio value="standard">Standard</Radio>
        <Radio value="manual">Manuell</Radio>
      </Radio.Group>
      {props.scanDirection === 'standard' && (
        <>
          <p>Richtung</p>
          <Radio.Group onChange={(event) => props.setHorizontalDirection(event.target.value)} defaultValue="rtl">
            <Radio value="rtl">Rechts nach Links</Radio>
            <Radio value="ltr">Links nach Rechts</Radio>
          </Radio.Group>
        </>

      )}
      <Button style={{ marginTop: '20px' }}
              type="primary"
              icon={props.scanDirection === 'standard' ? <CheckOutlined /> :  <SelectOutlined/> }
              onClick={() => props.handleScanDirectionChange(props.scanDirection)}>
        <p>{props.scanDirection === 'standard' ? "Anwenden" :  "Stühle auswählen" }</p>
      </Button>
      <Button style={{ marginTop: '20px' }} type="secondary" icon={<DeleteOutlined />}
              onClick={props.clearScanDirection}>
        <p>Löschen</p>
      </Button>
    </Flex>
  );
}

export default ScanDirectionContent;
